import { TbrData } from './../../common/interfaces/states/IElectronicJournalRecord';
import { CartItemViewData } from './../../items-list/business-logic/service/interfaces/cart-response';

export const getTbrReturnItemsTotal = (item: CartItemViewData, tbrData: TbrData): number => {
  const totalDepositItemPrice = getCurrentDepositItemPrice(item, tbrData);
  const totalItemPrice = getTotalItemPrice(item, tbrData);
  return totalItemPrice + totalDepositItemPrice;
};
export const getTbrNetAvailableItemsTotal = (item: CartItemViewData, tbrData: TbrData): number => {
  const totalDepositItemPrice = getTotalDepositPrice(item, tbrData);
  const tbrReturnItemsTotal = getTbrReturnItemsTotal(item, tbrData);
  return (Number(tbrData.ExtendedAmount) || 0) + totalDepositItemPrice - tbrReturnItemsTotal;
};

const getTotalItemPrice = (item: CartItemViewData, tbrData: TbrData): number => {
  const returnQty = tbrData.tbrReturnQty || 0;
  const pricePerUnit = (item.price?.unitPrice || 0) / (item.price?.quantity || 1);
  return returnQty * pricePerUnit;
};

export const getTotalDepositPrice = (item: CartItemViewData, tbrData: TbrData): number => {
  const availableQty = tbrData.tbrAvailableQty || 0;
  let totalDepositItemPrice = 0;

  if (item.linkedLines?.length) {
    const [firstLinkedLine] = item.linkedLines;
    const depositPrice = (firstLinkedLine.regularPrice ?? firstLinkedLine.price)?.unitPrice;

    totalDepositItemPrice = availableQty * (depositPrice ?? 0);
  }
  return totalDepositItemPrice;
};

const getCurrentDepositItemPrice = (item: CartItemViewData, tbrData: TbrData): number => {
  const returnQty = tbrData.tbrReturnQty || 0;
  let totalDepositItemPrice = 0;

  if (item.linkedLines?.length) {
    const [firstLinkedLine] = item.linkedLines;

    const depositItemPrice = (firstLinkedLine.regularPrice ?? firstLinkedLine.price)?.unitPrice;

    totalDepositItemPrice = returnQty * (depositItemPrice ?? 0);
  }
  return totalDepositItemPrice;
};
